import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Button, Typography, InlineAnchor } from '@figure/frontlib-gui';
import { Header as HeaderBase, SimpleFooter } from '@figure/figure-frontlib-gui';
import { useRedirect } from 'shared/hooks';
import { PageHeader } from 'shared/components/Typography';
import TimeoutImage from 'shared/assets/images/timeout.svg';

const ImageWrapper = styled.div`
  text-align: center;
  margin-bottom: 2rem;
  margin-top: 1.6rem;
`;

const BodyOne = styled(Typography.Body)`
  margin-bottom: 1rem;
`;

const Header = styled(HeaderBase)`
  & > * > * > ul {
    background-color: white;
  }
`;

const BaseContainer = styled.div`
  padding: 2rem;
  height: 100vh;
  background-color: #f5f7fd;
`;

const OuterContent = styled.div`
  width: 100vw;
  background: white;
`;

const Content = styled.div`
  max-width: 550px;
  padding: 2rem;
  margin-left: auto;
  margin-right: auto;
`;

const NotYetEligibleContainer = () => {
  const { t } = useTranslation();
  const { redirectToDashboard } = useRedirect();
  const companySingleName = t('companySingleName');
  const handleDashboardClick = () => redirectToDashboard();

  return (
    <BaseContainer>
      {/* @ts-ignore */}
      <Header />
      <OuterContent>
        <Content>
          <PageHeader>Not yet eligible for a {companySingleName} Personal Loan</PageHeader>
          <BodyOne>
            We'd love to serve you, however, you are not eligible for a new loan at this time. We
            require at least 90 days since your last issued loan OR having made your 3rd regularly
            scheduled monthly payment before you are eligible for a new loan.
          </BodyOne>
          <Typography.Body>
            If you have further questions, please contact us at{' '}
            <InlineAnchor href={`tel:+${t('phone.unformatted')}`}>
              {t('phone.formatted')}
            </InlineAnchor>{' '}
            (6am - 6pm PT, Mon - Sun)
          </Typography.Body>

          <ImageWrapper>
            <img src={TimeoutImage} alt="" />
          </ImageWrapper>
          <Button primary large center onClick={handleDashboardClick}>
            Go to dashboard
          </Button>
        </Content>
      </OuterContent>
      <SimpleFooter />
    </BaseContainer>
  );
};

export default NotYetEligibleContainer;
